(function () {
  /* ============================================================
     CONFIG
  ============================================================ */
  /*
   * BUNDLES — define one entry per promotion tier.
   * Keep sorted DESCENDING by qty — highest tier is checked first.
   *
   *   qty   : number of eligible units required
   *   price : flat bundle price in dollars for those units
   *   label : written to _bundle_tier so Liquid can show "3 for $99" etc.
   */
  var BUNDLES = [
    { qty: 3, price: 99, label: '3 for $99' },  // Buy 3 For $99
    { qty: 2, price: 79, label: '2 for $79' },  // Buy 2 For $79
  ];

  var EXCLUDED_TAGS = ['Leather Jacket', 'Leather Jackets', 'Bags']; // products with any of these tags are skipped (not counted, not discounted)
  var LOG_PREFIX = '[bundle-discount]';

  /* ─── checkout loading lock (CSS-only, re-render proof) ─────────────────────
   *
   * All previous DOM-manipulation approaches failed because UpCart fully
   * replaces the drawer markup on every cart change, wiping any inline styles
   * or injected nodes we added to its elements.
   *
   * Solution: a single <style> tag in <head> that is ADDED to lock and REMOVED
   * to unlock. The stylesheet lives outside UpCart's render tree so it is never
   * touched by re-renders. It targets UpCart's own classes:
   *
   *   LOCKED state (style tag present):
   *     .upcart-checkout-button-container-skeleton  → display:flex  (shimmer visible)
   *     .styles_Footer__checkoutButton__            → display:none  (real button hidden)
   *     #CartPopup                                  → pointer-events:none (whole drawer blocked)
   *
   *   UNLOCKED state (style tag absent):
   *     UpCart's own defaults take over — no overrides, no cleanup needed.
   */

  var LOCK_STYLE_ID = 'bundle-lock-styles';

  function applyButtonLock() {
    if (document.getElementById(LOCK_STYLE_ID)) { return; } // already locked
    var s = document.createElement('style');
    s.id = LOCK_STYLE_ID;
    s.textContent =
      '.upcart-checkout-button-container-skeleton{display:flex!important}' +
      '.styles_Footer__checkoutButton__{display:none!important}' +
      '#CartPopup{pointer-events:none!important}';
    document.head.appendChild(s);
    console.log(LOG_PREFIX, '[LOCK] Locked — skeleton visible, button hidden, cart blocked.');
  }

  function removeButtonLock() {
    var s = document.getElementById(LOCK_STYLE_ID);
    if (s) { s.parentNode.removeChild(s); }
    console.log(LOG_PREFIX, '[LOCK] Unlocked — UpCart defaults restored.');
  }

  var DEBOUNCE_MS = 400;
  var COOLDOWN_MS = 800;
  var MAX_PASSES = 2;                     // allows one re-run after a line split

  var isUpdating = false;
  var debounceTimer = null;
  var lastRunAt = 0;
  var selfDispatchCount = 0; // counts self-fired events to ignore

  /* ─── tag lookup ───
     /cart.js does NOT include product tags, so we fetch each product's
     /products/{handle}.js once and cache the tags for the session. */

  var productCache = {}; // handle -> { tags, variantPrices }

  function getProductData(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) { throw new Error('products/' + handle + '.js returned ' + res.status); }
        return res.json();
      })
      .then(function (product) {
        var tags = (product.tags || []).map(function (t) {
          return String(t).trim().toLowerCase();
        });
        // Build a variant_id -> price (cents) map from the product data,
        // which is always the true storefront price, unaffected by cart-level changes.
        var variantPrices = {};
        (product.variants || []).forEach(function (v) {
          variantPrices[v.id] = v.price; // already in cents
        });
        productCache[handle] = { tags: tags, variantPrices: variantPrices };
        return productCache[handle];
      });
  }

  function getProductTags(handle) {
    return getProductData(handle).then(function (d) { return d.tags; });
  }

  function getVariantOriginalPrice(item) {
    var cached = productCache[item.handle];
    if (cached && cached.variantPrices[item.variant_id] !== undefined) {
      return cached.variantPrices[item.variant_id];
    }
    // Fallback to cart data if product hasn't been fetched yet (shouldn't happen
    // in normal flow since splitEligible always fetches first).
    return typeof item.original_price === 'number' ? item.original_price : item.price;
  }

  function isExcludedByTags(tags) {
    return EXCLUDED_TAGS.some(function (ex) {
      return tags.indexOf(String(ex).trim().toLowerCase()) !== -1;
    });
  }

  /* ─── helpers ─── */

  // Base (pre-discount) unit price in cents, sourced from product data
  // so it is never affected by cart-level price changes.
  function unitCents(item) {
    return getVariantOriginalPrice(item);
  }

  // Async now: resolves { eligible, excluded } after tag lookups.
  // Items are excluded if they carry an excluded tag OR if their unit price is $0.
  function splitEligible(items) {
    var handles = [];
    items.forEach(function (item) {
      if (handles.indexOf(item.handle) === -1) { handles.push(item.handle); }
    });

    return Promise.all(handles.map(function (h) {
      return getProductTags(h).catch(function (err) {
        console.error(LOG_PREFIX, 'Could not fetch tags for', h, '- treating as EXCLUDED to be safe.', err);
        return null;
      });
    })).then(function (results) {
      var excludedByHandle = {};
      handles.forEach(function (h, i) {
        // null = tag fetch failed -> treat as excluded (never discount blindly)
        excludedByHandle[h] = results[i] === null ? true : isExcludedByTags(results[i]);
      });

      var eligible = [];
      var excluded = [];
      items.forEach(function (item) {
        var isExcluded = excludedByHandle[item.handle];
        var isFree     = unitCents(item) <= 0;
        if (isExcluded || isFree) {
          if (isFree) {
            console.log(LOG_PREFIX, '[EXCLUDED] title:', item.title, '| handle:', item.handle, '| variant:', item.variant_id, '| qty:', item.quantity, '| reason: free item ($0)');
          } else {
            var matchedTags = EXCLUDED_TAGS.filter(function (ex) {
              return (excludedByHandle[item.handle + '__tags'] || []).indexOf(String(ex).trim().toLowerCase()) !== -1;
            });
            console.log(LOG_PREFIX, '[EXCLUDED] title:', item.title, '| handle:', item.handle, '| variant:', item.variant_id, '| qty:', item.quantity, '| price: $' + (unitCents(item) / 100).toFixed(2));
          }
          excluded.push(item);
        } else {
          console.log(LOG_PREFIX, '[ELIGIBLE] title:', item.title, '| handle:', item.handle, '| variant:', item.variant_id, '| qty:', item.quantity, '| price: $' + (unitCents(item) / 100).toFixed(2));
          eligible.push(item);
        }
      });

      console.log(LOG_PREFIX, 'splitEligible summary — eligible units:', eligible.reduce(function(s,i){return s+i.quantity;},0), '| excluded units:', excluded.reduce(function(s,i){return s+i.quantity;},0));
      return { eligible: eligible, excluded: excluded };
    });
  }

  /*
   * Count total eligible UNITS (not lines).
   * A single line with qty=3 counts as 3 units, satisfying a tier of qty=3 on its own.
   * e.g. one item × qty 3  → count = 3.
   *      three items × qty 1 each → count = 3.
   */
  function getEligibleCount(eligible) {
    return eligible.reduce(function (s, item) { return s + item.quantity; }, 0);
  }

  /*
   * Return the best (highest qty) BUNDLES tier the cart qualifies for.
   * Returns null if no tier is satisfied.
   */
  function getBestTier(count) {
    for (var i = 0; i < BUNDLES.length; i++) {
      if (count >= BUNDLES[i].qty) { return BUNDLES[i]; }
    }
    return null;
  }

  /*
   * Pick exactly tierQty units for the bundle.
   *
   * A single line with qty >= tierQty is treated as tierQty individual units:
   *   - qty === tierQty → the whole line goes into bundled.
   *   - qty >  tierQty → the line straddles the boundary; performSplit()
   *     breaks it into a bundled line (qty: tierQty) and a full-price
   *     remainder, then re-runs. This is required because Shopify applies
   *     line item properties to all units on a line.
   *
   * Lines already carrying the _bundled_item marker are preferred (keeps the
   * selection stable across runs, especially after a line split); otherwise
   * cart order decides.
   */
  function selectBundle(eligible, tierQty) {
    var sorted = eligible.slice().sort(function (a, b) {
      var am = a.properties && a.properties._bundled_item === 'true' ? 0 : 1;
      var bm = b.properties && b.properties._bundled_item === 'true' ? 0 : 1;
      if (am !== bm) return am - bm;
      return a._cartLine - b._cartLine;
    });

    var remaining = tierQty;
    var bundled = [];
    var leftover = [];
    var straddle = null;

    sorted.forEach(function (item) {
      if (remaining <= 0) {
        leftover.push(item);
        return;
      }
      if (item.quantity <= remaining) {
        bundled.push({ item: item, qty: item.quantity });
        remaining -= item.quantity;
      } else {
        // Line partially in the bundle -> must be split into two lines,
        // because line item properties apply to the whole line.
        straddle = {
          item: item,
          bundledQty: remaining,
          restQty: item.quantity - remaining,
        };
        remaining = 0;
      }
    });

    console.log(
      LOG_PREFIX, 'selectBundle ->',
      'bundled lines:', bundled.length,
      'straddle:', straddle ? straddle.item.title : 'none',
      'leftover lines:', leftover.length
    );
    return { bundled: bundled, straddle: straddle, leftover: leftover };
  }

  /*
   * Proportional discount allocation.
   *
   * The discount percentage is derived exclusively from the selected bundle
   * lines' own total — NOT from all eligible items in the cart.
   *
   *   bundleOrigTotal = sum of (unitCents × qty) for the selected lines only
   *   discountPct     = (bundleOrigTotal − bundleCents) / bundleOrigTotal
   *
   * Each line then receives:
   *   finalUnitCents  = round(unitCents × (1 − discountPct))
   *
   * Example (BUNDLE_PRICE = $75, MIN_QTY = 3):
   *   Cart:  A=$30, B=$40, C=$50, D=$60, E=$70
   *   Selected bundle: A + B + C  → bundleOrigTotal = $120
   *   discountPct = (120 − 75) / 120 = 37.5%
   *   A: $30 × 62.5% = $18.75
   *   B: $40 × 62.5% = $25.00
   *   C: $50 × 62.5% = $31.25  ← last line absorbs any rounding remainder
   *   Total = $75.00  ✓
   *   D and E remain at full price — they are not part of the bundle.
   *
   * The last line in ascending-unit-price order absorbs any whole-cent
   * rounding remainder so the sum always lands exactly on bundleCents.
   * Rounding is applied per unit so Shopify stores a clean unit price.
   */
  function allocateBundlePrices(lines, bundleCents) {
    // Sum only the selected bundle lines.
    var bundleOrigTotal = lines.reduce(function (s, l) {
      return s + l.unitCents * l.qty;
    }, 0);

    var deltaCents = bundleOrigTotal - bundleCents;

    console.log(
      LOG_PREFIX,
      'allocate -> bundleOrigTotal:', bundleOrigTotal,
      'bundleCents:', bundleCents,
      'deltaCents:', deltaCents
    );

    if (deltaCents <= 0) {
      console.log(LOG_PREFIX, 'Bundle price is not cheaper than the selected items\' original total. No discount applied.');
      return null;
    }

    // Discount rate is based solely on the selected bundle total.
    var discountPct = deltaCents / bundleOrigTotal;
    console.log(LOG_PREFIX, 'discountPct:', (discountPct * 100).toFixed(4) + '%');

    // Sort descending by unit price so the cheapest line comes last.
    // The last (cheapest) line absorbs the rounding remainder — a cent
    // adjustment is least noticeable on the lowest-priced item.
    var order = lines.slice().sort(function (a, b) { return b.unitCents - a.unitCents; });

    var remainingBundleCents = bundleCents;
    var out = [];

    order.forEach(function (l, i) {
      var isLast = i === order.length - 1;
      var finalUnit;

      if (isLast) {
        // Absorb any rounding remainder so the grand total hits bundleCents exactly.
        finalUnit = Math.round(remainingBundleCents / l.qty);
        var diff = remainingBundleCents - finalUnit * l.qty;
        if (diff !== 0) {
          console.warn(
            LOG_PREFIX,
            'Bundle total off by', diff,
            'cents on the remainder-absorbing line — not evenly divisible across its quantity.'
          );
        }
      } else {
        // Apply the same proportional discount to this line.
        // finalUnit = unitCents × (1 − discountPct), rounded to the nearest cent.
        finalUnit = Math.round(l.unitCents * (1 - discountPct));
      }

      finalUnit = Math.max(0, finalUnit);
      remainingBundleCents -= finalUnit * l.qty;
      out.push({ item: l.item, finalUnitCents: finalUnit });
    });

    console.log(LOG_PREFIX, 'allocate result:', out.map(function (r) {
      return {
        title: r.item.title,
        key: r.item.key,
        originalUnit: (unitCents(r.item) / 100).toFixed(2),
        finalUnit: (r.finalUnitCents / 100).toFixed(2),
      };
    }));

    return out;
  }

  /* ─── line splitting ─── */

  function copyPublicProps(props) {
    var out = {};
    if (!props) return out;
    var BUNDLE_KEYS = { _bundled_item: 1, _bundle_tier: 1, _original_price: 1, _discounted_price: 1 };
    Object.keys(props).forEach(function (k) {
      if (!BUNDLE_KEYS[k]) { out[k] = props[k]; }
    });
    return out;
  }

  function performSplit(straddle, done, fail) {
    console.log(LOG_PREFIX, 'Splitting line', straddle.item._cartLine, '(' + straddle.item.title + '):',
      straddle.bundledQty, 'bundled /', straddle.restQty, 'full price');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: straddle.item._cartLine,
        quantity: straddle.restQty,
        properties: copyPublicProps(straddle.item.properties),
      }),
    })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart/change.js returned ' + res.status); }
        return res.json();
      })
      .then(function () {
        var props = copyPublicProps(straddle.item.properties);
        props._bundled_item = 'true';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: straddle.item.variant_id,
              quantity: straddle.bundledQty,
              properties: props,
            }],
          }),
        });
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart/add.js returned ' + res.status); }
        return res.json();
      })
      .then(function () { done(); })
      .catch(function (err) { fail(err); });
  }

  /* ─── core routine ─── */

  function applyBundleDiscount(pass) {
    pass = pass || 1;
    console.log(LOG_PREFIX, 'applyBundleDiscount() running. Pass', pass);

    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) { throw new Error('cart.js returned ' + res.status); }
        return res.json();
      })
      .then(function (cart) {
        console.log(LOG_PREFIX, 'Fetched cart.js. Item count:', cart.item_count);

        var items = cart.items;
        if (!items || !items.length) {
          console.log(LOG_PREFIX, 'Cart is empty, nothing to do.');
          finishRun(false);
          return;
        }

        // /cart/change.js identifies a line by its 1-based position.
        items.forEach(function (item, idx) { item._cartLine = idx + 1; });

        return splitEligible(items).then(function (split) {
          var count = getEligibleCount(split.eligible);
          var tier  = getBestTier(count);

          console.log(
            LOG_PREFIX,
            'Eligible units:', count,
            '(across', split.eligible.length, 'line' + (split.eligible.length === 1 ? '' : 's') + ').',
            tier ? 'Active tier: ' + tier.label + '.' : 'No bundle tier qualifies.'
          );

          // ---- Case 1: no tier qualifies -> clear any stale bundle props ----
          if (!tier) {
            console.log(LOG_PREFIX, 'No qualifying tier. Clearing any stale bundle props.');
            runOrFinish(buildClearUpdates(items));
            return;
          }

          var sel = selectBundle(split.eligible, tier.qty);

          // ---- Case 2: a line straddles the bundle boundary -> split it, re-run ----
          if (sel.straddle) {
            if (pass >= MAX_PASSES) {
              console.warn(LOG_PREFIX, 'Straddling line still present after split attempt; skipping this run.');
              finishRun(false);
              return;
            }
            performSplit(sel.straddle, function () {
              applyBundleDiscount(pass + 1);
            }, function (err) {
              console.error(LOG_PREFIX, 'Line split failed:', err);
              finishRun(false);
            });
            return;
          }

          // ---- Case 3: bundle exactly tier.qty units, leave the rest alone ----
          var lines = sel.bundled.map(function (b) {
            return { item: b.item, qty: b.qty, unitCents: unitCents(b.item) };
          });

          var bundleCents = Math.round(tier.price * 100);
          var alloc = allocateBundlePrices(lines, bundleCents);

          var updates = [];

          if (!alloc) {
            // Bundle price not cheaper than originals — clear any stale props.
            updates = buildClearUpdates(items);
          } else {
            alloc.forEach(function (entry) {
              var item = entry.item;
              var origStr = (unitCents(item) / 100).toFixed(2);
              var discStr = (entry.finalUnitCents / 100).toFixed(2);
              var p = item.properties || {};

              // Write update only when something has actually changed.
              if (
                p._bundled_item    !== 'true'    ||
                p._bundle_tier     !== tier.label ||
                p._original_price  !== origStr    ||
                p._discounted_price !== discStr
              ) {
                var newProps = copyPublicProps(p);
                newProps._bundled_item    = 'true';
                newProps._bundle_tier     = tier.label;
                newProps._original_price  = origStr;
                newProps._discounted_price = discStr;
                updates.push({ line: item._cartLine, properties: newProps, quantity: item.quantity });
              }
            });

            // Excluded items (by tag) and leftover eligible units must NEVER carry
            // bundle props — cleared unconditionally on every run.
            sel.leftover.concat(split.excluded).forEach(function (item) {
              var p = item.properties || {};
              var reason = split.excluded.indexOf(item) !== -1 ? 'tag-excluded' : 'leftover (outside bundle qty)';
              if (p._bundled_item || p._bundle_tier || p._original_price || p._discounted_price) {
                console.log(LOG_PREFIX, '[CLEAR] Removing bundle props from "' + item.title + '" (' + reason + ')');
              }
              updates.push({ line: item._cartLine, properties: buildFullPriceProps(item), quantity: item.quantity });
            });
          }

          runOrFinish(updates);
        });
      })
      .catch(function (err) {
        console.error(LOG_PREFIX, 'Bundle discount error (likely rate limited or network issue):', err);
        finishRun(false);
      });
  }

  /*
   * Normalises the three bundle keys to a "no discount active" state.
   * Shopify does not reliably drop line item properties when keys are
   * omitted or deleted, so we write explicit "false / full price" values
   * instead of trying to delete them.
   *
   *   _bundled_item     -> 'false'
   *   _original_price   -> real unit price (unchanged)
   *   _discounted_price -> same as _original_price  (equal = no discount)
   *
   * Liquid / the theme should gate any discount UI on _bundled_item == 'true',
   * so these values are always safe to render.
   */
  function buildNoDiscountProps(item) {
    var fullPriceStr = (unitCents(item) / 100).toFixed(2);
    var newProps = copyPublicProps(item.properties);
    newProps._bundled_item    = 'false';
    newProps._bundle_tier     = '';
    newProps._original_price  = fullPriceStr;
    newProps._discounted_price = fullPriceStr;
    return newProps;
  }

  function buildClearUpdates(items) {
    var updates = [];
    items.forEach(function (item) {
      var p = item.properties || {};
      if (p._bundled_item || p._bundle_tier || p._original_price || p._discounted_price) {
        updates.push({ line: item._cartLine, properties: buildNoDiscountProps(item), quantity: item.quantity });
      }
    });
    return updates;
  }

  function buildFullPriceProps(item) {
    return buildNoDiscountProps(item);
  }

  function runOrFinish(updates) {
    console.log(LOG_PREFIX, 'Updates queued:', updates.length);
    if (!updates.length) {
      console.log(LOG_PREFIX, 'No updates needed, done.');
      finishRun(false);
      return;
    }
    // Descending line order so updating a line never shifts the position
    // of a line we haven't touched yet.
    updates.sort(function (a, b) { return b.line - a.line; });
    runUpdatesSequentially(updates, function () {
      finishRun(true);
    });
  }

  function finishRun(changed) {
    isUpdating = false;
    console.log(LOG_PREFIX, 'Run complete. isUpdating reset to false. changed =', changed);

    if (changed) {
      // Keep the lock active while UpCart re-renders the drawer so the
      // skeleton stays visible during the re-paint. The lock is lifted
      // inside the aftersell cart-updated listener once UpCart confirms
      // the drawer has finished re-rendering (selfDispatchCount reaches 0).
      selfDispatchCount = typeof window.upcartRefreshCart === 'function' ? 2 : 1;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof window.upcartRefreshCart === 'function') {
        console.log(LOG_PREFIX, 'Refreshing UpCart drawer — lock held until re-render completes.');
        window.upcartRefreshCart();
        return; // unlock deferred to aftersell cart-updated listener
      }
    }

    // No cart change, or no UpCart present — safe to unlock immediately.
    removeButtonLock();
  }

  function runUpdatesSequentially(updates, done) {
    var i = 0;
    function next() {
      if (i >= updates.length) {
        done();
        return;
      }
      var u = updates[i++];
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: u.line,
          quantity: u.quantity,
          properties: u.properties,
        }),
      })
        .then(function (res) {
          if (!res.ok) { throw new Error('cart/change.js returned ' + res.status); }
          return res.json();
        })
        .then(function () { next(); })
        .catch(function (err) {
          console.error(LOG_PREFIX, 'Line update error (stopping this batch):', err);
          done();
        });
    }
    next();
  }

  /* ─── trigger, debounced + cooldown-guarded ─── */

  var retryTimer = null; // schedules a catch-up run if one gets skipped below

  function requestRun(triggerLock) {
    if (selfDispatchCount > 0) {
      selfDispatchCount--;
      console.log(LOG_PREFIX, 'Ignoring self-dispatched event echo. Remaining:', selfDispatchCount);
      return;
    }

    // Lock immediately — before the debounce delay — so the skeleton appears
    // the instant UpCart fires its cart-updated event, not 400 ms later.
    if (triggerLock) {
      applyButtonLock();
    }

    if (debounceTimer) { clearTimeout(debounceTimer); }

    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      attemptRun();
    }, DEBOUNCE_MS);
  }

  // Tries to run now; if blocked, schedules exactly one retry for when the
  // block clears, so a change that arrives mid-run or mid-cooldown is never
  // silently dropped — it just runs a little later instead.
  function attemptRun() {
    var now = Date.now();

    if (isUpdating) {
      console.log(LOG_PREFIX, 'Busy — will retry once the current run finishes.');
      scheduleRetry(COOLDOWN_MS);
      return;
    }
    if (now - lastRunAt < COOLDOWN_MS) {
      var wait = COOLDOWN_MS - (now - lastRunAt);
      console.log(LOG_PREFIX, 'Inside cooldown — will retry in', wait, 'ms.');
      scheduleRetry(wait);
      return;
    }

    isUpdating = true;
    lastRunAt = now;
    applyBundleDiscount(1);
  }

  function scheduleRetry(delayMs) {
    if (retryTimer) { clearTimeout(retryTimer); }
    retryTimer = setTimeout(function () {
      retryTimer = null;
      attemptRun();
    }, delayMs + 20); // small buffer past the exact window edge
  }

  console.log(LOG_PREFIX, 'Script loaded, listener attached to cart:refresh.');

  document.addEventListener('cart:refresh', function () {
    console.log(LOG_PREFIX, 'cart:refresh event caught.');
    requestRun(false); // self-fired — do not re-lock
  });

  // UpCart fires this after every cart mutation AND after upcartRefreshCart()
  // finishes re-rendering. We use that second fire to unlock the button —
  // the drawer is fully painted at that point.
  window.addEventListener('aftersell-upcart:public-events:cart-updated', function (e) {
    console.log(LOG_PREFIX, 'UpCart cart-updated event caught.', e.detail);

    if (selfDispatchCount > 0) {
      selfDispatchCount--;
      console.log(LOG_PREFIX, '[LOCK] Self-dispatch echo consumed. Remaining:', selfDispatchCount);
      if (selfDispatchCount === 0) {
        // UpCart has finished re-rendering — safe to unlock now.
        removeButtonLock();
      }
      return;
    }

    requestRun(true); // real cart change — lock immediately
  });

  // Fires once when the drawer finishes initializing — silent check, no lock.
  window.addEventListener('aftersell-upcart:public-events:initialized', function (e) {
    console.log(LOG_PREFIX, 'UpCart initialized event caught.', e.detail);
    requestRun(false);
  });

  document.addEventListener('DOMContentLoaded', function () {
    console.log(LOG_PREFIX, 'DOMContentLoaded — running initial check.');
    requestRun(false);
  });
})();


// (function () {
//   /* ============================================================
//      CONFIG
//   ============================================================ */
//   var MIN_QTY = 3;                        // exactly this many eligible units get the bundle deal
//   var EXCLUDED_TAGS = ['Jackets', 'Bags']; // products with any of these tags are skipped (not counted, not discounted)
//   var BUNDLE_PRICE = 75;                  // flat total price for the MIN_QTY bundled units
//   var LOG_PREFIX = '[bundle-discount]';

//   var DEBOUNCE_MS = 400;
//   var COOLDOWN_MS = 800;
//   var MAX_PASSES = 2;                     // allows one re-run after a line split

//   var isUpdating = false;
//   var debounceTimer = null;
//   var lastRunAt = 0;
//   var selfDispatchCount = 0; // counts self-fired events to ignore

//   /* ─── tag lookup ───
//      /cart.js does NOT include product tags, so we fetch each product's
//      /products/{handle}.js once and cache the tags for the session. */

//   var productCache = {}; // handle -> { tags, variantPrices }

//   function getProductData(handle) {
//     if (productCache[handle]) {
//       return Promise.resolve(productCache[handle]);
//     }
//     return fetch('/products/' + handle + '.js')
//       .then(function (res) {
//         if (!res.ok) { throw new Error('products/' + handle + '.js returned ' + res.status); }
//         return res.json();
//       })
//       .then(function (product) {
//         var tags = (product.tags || []).map(function (t) {
//           return String(t).trim().toLowerCase();
//         });
//         // Build a variant_id -> price (cents) map from the product data,
//         // which is always the true storefront price, unaffected by cart-level changes.
//         var variantPrices = {};
//         (product.variants || []).forEach(function (v) {
//           variantPrices[v.id] = v.price; // already in cents
//         });
//         productCache[handle] = { tags: tags, variantPrices: variantPrices };
//         return productCache[handle];
//       });
//   }

//   function getProductTags(handle) {
//     return getProductData(handle).then(function (d) { return d.tags; });
//   }

//   function getVariantOriginalPrice(item) {
//     var cached = productCache[item.handle];
//     if (cached && cached.variantPrices[item.variant_id] !== undefined) {
//       return cached.variantPrices[item.variant_id];
//     }
//     // Fallback to cart data if product hasn't been fetched yet (shouldn't happen
//     // in normal flow since splitEligible always fetches first).
//     return typeof item.original_price === 'number' ? item.original_price : item.price;
//   }

//   function isExcludedByTags(tags) {
//     return EXCLUDED_TAGS.some(function (ex) {
//       return tags.indexOf(String(ex).trim().toLowerCase()) !== -1;
//     });
//   }

//   /* ─── helpers ─── */

//   // Base (pre-discount) unit price in cents, sourced from product data
//   // so it is never affected by cart-level price changes.
//   function unitCents(item) {
//     return getVariantOriginalPrice(item);
//   }

//   // Async now: resolves { eligible, excluded } after tag lookups.
//   function splitEligible(items) {
//     var handles = [];
//     items.forEach(function (item) {
//       if (handles.indexOf(item.handle) === -1) { handles.push(item.handle); }
//     });

//     return Promise.all(handles.map(function (h) {
//       return getProductTags(h).catch(function (err) {
//         console.error(LOG_PREFIX, 'Could not fetch tags for', h, '- treating as EXCLUDED to be safe.', err);
//         return null;
//       });
//     })).then(function (results) {
//       var excludedByHandle = {};
//       handles.forEach(function (h, i) {
//         // null = tag fetch failed -> treat as excluded (never discount blindly)
//         excludedByHandle[h] = results[i] === null ? true : isExcludedByTags(results[i]);
//       });

//       var eligible = [];
//       var excluded = [];
//       items.forEach(function (item) {
//         var tagExcluded = excludedByHandle[item.handle];
//         var isFree = unitCents(item) <= 0;
//         if (tagExcluded || isFree) {
//           if (isFree) {
//             console.log(LOG_PREFIX, 'Excluding free item ($0):', item.title);
//           }
//           excluded.push(item);
//         } else {
//           eligible.push(item);
//         }
//       });

//       console.log(LOG_PREFIX, 'splitEligible ->', 'eligible:', eligible.length, 'excluded:', excluded.length);
//       return { eligible: eligible, excluded: excluded };
//     });
//   }

//   function getEligibleCount(eligible) {
//     return eligible.reduce(function (s, item) { return s + item.quantity; }, 0);
//   }

//   /*
//    * Pick exactly MIN_QTY units for the bundle.
//    * Lines already carrying the _bundled_item marker are preferred (keeps the
//    * selection stable across runs, especially after a line split); otherwise
//    * cart order decides.
//    */
//   function selectBundle(eligible) {
//     var sorted = eligible.slice().sort(function (a, b) {
//       var am = a.properties && a.properties._bundled_item === 'true' ? 0 : 1;
//       var bm = b.properties && b.properties._bundled_item === 'true' ? 0 : 1;
//       if (am !== bm) return am - bm;
//       return a._cartLine - b._cartLine;
//     });

//     var remaining = MIN_QTY;
//     var bundled = [];
//     var leftover = [];
//     var straddle = null;

//     sorted.forEach(function (item) {
//       if (remaining <= 0) {
//         leftover.push(item);
//         return;
//       }
//       if (item.quantity <= remaining) {
//         bundled.push({ item: item, qty: item.quantity });
//         remaining -= item.quantity;
//       } else {
//         // Line partially in the bundle -> must be split into two lines,
//         // because line item properties apply to the whole line.
//         straddle = {
//           item: item,
//           bundledQty: remaining,
//           restQty: item.quantity - remaining,
//         };
//         remaining = 0;
//       }
//     });

//     console.log(
//       LOG_PREFIX, 'selectBundle ->',
//       'bundled lines:', bundled.length,
//       'straddle:', straddle ? straddle.item.title : 'none',
//       'leftover lines:', leftover.length
//     );
//     return { bundled: bundled, straddle: straddle, leftover: leftover };
//   }

//   /*
//    * Percentage-based allocation.
//    *
//    *   delta       = totalOrigCents - bundleCents   (amount that must come off)
//    *   discountPct = delta / totalOrigCents          (same rate applied to every line)
//    *
//    * Every eligible line is discounted by that SAME percentage, so a $46.92
//    * item gives up more cents than a $24.36 item, but both lose the same
//    * proportion of their price. Whole-cent rounding per line means the sum
//    * can drift a cent or two from bundleCents, so the last line (by
//    * ascending unit price, so it's usually the item best able to absorb a
//    * cent without looking odd) absorbs the remainder to land exactly on
//    * bundleCents.
//    */
//   function allocateBundlePrices(lines, bundleCents) {
//     var totalOrigCents = lines.reduce(function (s, l) {
//       return s + l.unitCents * l.qty;
//     }, 0);

//     var deltaCents = totalOrigCents - bundleCents;

//     console.log(LOG_PREFIX, 'allocate -> totalOrigCents:', totalOrigCents, 'bundleCents:', bundleCents, 'deltaCents:', deltaCents);

//     if (deltaCents <= 0) {
//       console.log(LOG_PREFIX, 'Bundle price not cheaper than original total. No discount.');
//       return null;
//     }

//     var discountPct = deltaCents / totalOrigCents;
//     console.log(LOG_PREFIX, 'discountPct:', (discountPct * 100).toFixed(4) + '%');

//     // Ascending unit price -> cheapest line last, so it absorbs the
//     // rounding remainder (a cent or two on a cheap item is less noticeable
//     // than on the priciest one).
//     var order = lines.slice().sort(function (a, b) { return b.unitCents - a.unitCents; });

//     var remainingBundleCents = bundleCents;
//     var out = [];

//     order.forEach(function (l, i) {
//       var isLast = i === order.length - 1;
//       var finalUnit;

//       if (isLast) {
//         finalUnit = Math.round(remainingBundleCents / l.qty);
//         var diff = remainingBundleCents - finalUnit * l.qty;
//         if (diff !== 0) {
//           console.warn(LOG_PREFIX, 'Bundle total off by', diff, 'cents (not evenly divisible across the remainder-absorbing line).');
//         }
//       } else {
//         var lineDiscount = Math.round(l.unitCents * discountPct * l.qty);
//         var finalLineTotal = l.unitCents * l.qty - lineDiscount;
//         finalUnit = Math.round(finalLineTotal / l.qty);
//       }

//       finalUnit = Math.max(0, finalUnit);
//       remainingBundleCents -= finalUnit * l.qty;
//       out.push({ item: l.item, finalUnitCents: finalUnit });
//     });

//     console.log(LOG_PREFIX, 'allocate result:', out.map(function (r) {
//       return { title: r.item.title, key: r.item.key, finalUnit: (r.finalUnitCents / 100).toFixed(2) };
//     }));

//     return out;
//   }

//   /* ─── line splitting ─── */

//   function copyPublicProps(props) {
//     var out = {};
//     if (!props) return out;
//     Object.keys(props).forEach(function (k) {
//       if (k !== '_bundled_item' && k !== '_original_price' && k !== '_discounted_price') {
//         out[k] = props[k];
//       }
//     });
//     return out;
//   }

//   function performSplit(straddle, done, fail) {
//     console.log(LOG_PREFIX, 'Splitting line', straddle.item._cartLine, '(' + straddle.item.title + '):',
//       straddle.bundledQty, 'bundled /', straddle.restQty, 'full price');

//     fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         line: straddle.item._cartLine,
//         quantity: straddle.restQty,
//         properties: copyPublicProps(straddle.item.properties),
//       }),
//     })
//       .then(function (res) {
//         if (!res.ok) { throw new Error('cart/change.js returned ' + res.status); }
//         return res.json();
//       })
//       .then(function () {
//         var props = copyPublicProps(straddle.item.properties);
//         props._bundled_item = 'true';
//         return fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             items: [{
//               id: straddle.item.variant_id,
//               quantity: straddle.bundledQty,
//               properties: props,
//             }],
//           }),
//         });
//       })
//       .then(function (res) {
//         if (!res.ok) { throw new Error('cart/add.js returned ' + res.status); }
//         return res.json();
//       })
//       .then(function () { done(); })
//       .catch(function (err) { fail(err); });
//   }

//   /* ─── core routine ─── */

//   function applyBundleDiscount(pass) {
//     pass = pass || 1;
//     console.log(LOG_PREFIX, 'applyBundleDiscount() running. Pass', pass);

//     fetch('/cart.js')
//       .then(function (res) {
//         if (!res.ok) { throw new Error('cart.js returned ' + res.status); }
//         return res.json();
//       })
//       .then(function (cart) {
//         console.log(LOG_PREFIX, 'Fetched cart.js. Item count:', cart.item_count);

//         var items = cart.items;
//         if (!items || !items.length) {
//           console.log(LOG_PREFIX, 'Cart is empty, nothing to do.');
//           finishRun(false);
//           return;
//         }

//         // /cart/change.js identifies a line by its 1-based position.
//         items.forEach(function (item, idx) { item._cartLine = idx + 1; });

//         return splitEligible(items).then(function (split) {
//           var count = getEligibleCount(split.eligible);

//           // ---- Case 1: not enough eligible units -> everything full price ----
//           if (count < MIN_QTY) {
//             console.log(LOG_PREFIX, 'Below MIN_QTY (' + MIN_QTY + '). Count =', count, '- clearing any stale bundle props.');
//             runOrFinish(buildClearUpdates(items));
//             return;
//           }

//           var sel = selectBundle(split.eligible);

//           // ---- Case 2: a line straddles the bundle boundary -> split it, re-run ----
//           if (sel.straddle) {
//             if (pass >= MAX_PASSES) {
//               console.warn(LOG_PREFIX, 'Straddling line still present after split attempt; skipping this run.');
//               finishRun(false);
//               return;
//             }
//             performSplit(sel.straddle, function () {
//               applyBundleDiscount(pass + 1);
//             }, function (err) {
//               console.error(LOG_PREFIX, 'Line split failed:', err);
//               finishRun(false);
//             });
//             return;
//           }

//           // ---- Case 3: bundle exactly MIN_QTY units, leave the rest alone ----
//           var lines = sel.bundled.map(function (b) {
//             return { item: b.item, qty: b.qty, unitCents: unitCents(b.item) };
//           });

//           var alloc = allocateBundlePrices(lines, Math.round(BUNDLE_PRICE * 100));

//           var updates = [];

//           if (!alloc) {
//             updates = buildClearUpdates(items);
//           } else {
//             alloc.forEach(function (entry) {
//               var item = entry.item;
//               var origStr = (unitCents(item) / 100).toFixed(2);
//               var discStr = (entry.finalUnitCents / 100).toFixed(2);
//               var p = item.properties || {};

//               if (p._bundled_item !== 'true' || p._original_price !== origStr || p._discounted_price !== discStr) {
//                 var newProps = copyPublicProps(p);
//                 newProps._bundled_item = 'true';
//                 newProps._original_price = origStr;
//                 newProps._discounted_price = discStr;
//                 updates.push({ line: item._cartLine, properties: newProps, quantity: item.quantity });
//               }
//             });

//             // Leftover eligible units (4th item onwards) + tag-excluded items:
//             // must NOT carry bundle properties/pricing.
//             sel.leftover.concat(split.excluded).forEach(function (item) {
//               var p = item.properties || {};
//               if (p._bundled_item || p._original_price || p._discounted_price) {
//                 console.log(LOG_PREFIX, 'Clearing bundle props on non-bundled item:', item.title);
//                 updates.push({ line: item._cartLine, properties: buildFullPriceProps(item), quantity: item.quantity });
//               }
//             });
//           }

//           runOrFinish(updates);
//         });
//       })
//       .catch(function (err) {
//         console.error(LOG_PREFIX, 'Bundle discount error (likely rate limited or network issue):', err);
//         finishRun(false);
//       });
//   }

//   /*
//    * Builds a clean properties object with all three bundle keys fully
//    * removed. copyPublicProps() strips them by omission; the explicit
//    * delete calls are a belt-and-suspenders safety net.
//    */
//   /*
//    * Shopify does not reliably drop line item properties when keys are
//    * omitted or deleted. Instead we normalise the three bundle keys to a
//    * "no discount active" state:
//    *   _bundled_item     -> 'false'
//    *   _original_price   -> real unit price (unchanged)
//    *   _discounted_price -> same as _original_price (equal = no discount)
//    *
//    * Liquid / the theme should gate any discount UI on _bundled_item == 'true',
//    * so these values are always safe to render.
//    */
//   function buildNoDiscountProps(item) {
//     var fullPriceStr = (unitCents(item) / 100).toFixed(2);
//     var newProps = copyPublicProps(item.properties);
//     newProps._bundled_item = 'false';
//     newProps._original_price = fullPriceStr;
//     newProps._discounted_price = fullPriceStr;
//     return newProps;
//   }

//   function buildClearUpdates(items) {
//     var updates = [];
//     items.forEach(function (item) {
//       var p = item.properties || {};
//       if (p._bundled_item || p._original_price || p._discounted_price) {
//         updates.push({ line: item._cartLine, properties: buildNoDiscountProps(item), quantity: item.quantity });
//       }
//     });
//     return updates;
//   }

//   function buildFullPriceProps(item) {
//     return buildNoDiscountProps(item);
//   }

//   function runOrFinish(updates) {
//     console.log(LOG_PREFIX, 'Updates queued:', updates.length);
//     if (!updates.length) {
//       console.log(LOG_PREFIX, 'No updates needed, done.');
//       finishRun(false);
//       return;
//     }
//     // Descending line order so updating a line never shifts the position
//     // of a line we haven't touched yet.
//     updates.sort(function (a, b) { return b.line - a.line; });
//     runUpdatesSequentially(updates, function () {
//       finishRun(true);
//     });
//   }

//   function finishRun(changed) {
//     isUpdating = false;
//     console.log(LOG_PREFIX, 'Run complete. isUpdating reset to false. changed =', changed);
//     if (changed) {
//       // Count how many self-fired events to ignore: always 1 for cart:refresh,
//       // plus 1 more if upcartRefreshCart() will fire aftersell cart-updated.
//       selfDispatchCount = typeof window.upcartRefreshCart === 'function' ? 2 : 1;
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//       if (typeof window.upcartRefreshCart === 'function') {
//         console.log(LOG_PREFIX, 'Refreshing UpCart drawer.');
//         window.upcartRefreshCart();
//       }
//     }
//   }




//   function runUpdatesSequentially(updates, done) {
//     var i = 0;
//     function next() {
//       if (i >= updates.length) {
//         done();
//         return;
//       }
//       var u = updates[i++];
//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           line: u.line,
//           quantity: u.quantity,
//           properties: u.properties,
//         }),
//       })
//         .then(function (res) {
//           if (!res.ok) { throw new Error('cart/change.js returned ' + res.status); }
//           return res.json();
//         })
//         .then(function () { next(); })
//         .catch(function (err) {
//           console.error(LOG_PREFIX, 'Line update error (stopping this batch):', err);
//           done();
//         });
//     }
//     next();
//   }

//   /* ─── trigger, debounced + cooldown-guarded ─── */

//   var retryTimer = null; // schedules a catch-up run if one gets skipped below

//   function requestRun() {
//     if (selfDispatchCount > 0) {
//       selfDispatchCount--;
//       console.log(LOG_PREFIX, 'Ignoring self-dispatched event echo. Remaining:', selfDispatchCount);
//       return;
//     }

//     if (debounceTimer) { clearTimeout(debounceTimer); }

//     debounceTimer = setTimeout(function () {
//       debounceTimer = null;
//       attemptRun();
//     }, DEBOUNCE_MS);
//   }

//   // Tries to run now; if blocked, schedules exactly one retry for when the
//   // block clears, so a change that arrives mid-run or mid-cooldown is never
//   // silently dropped — it just runs a little later instead.
//   function attemptRun() {
//     var now = Date.now();

//     if (isUpdating) {
//       console.log(LOG_PREFIX, 'Busy — will retry once the current run finishes.');
//       scheduleRetry(COOLDOWN_MS);
//       return;
//     }
//     if (now - lastRunAt < COOLDOWN_MS) {
//       var wait = COOLDOWN_MS - (now - lastRunAt);
//       console.log(LOG_PREFIX, 'Inside cooldown — will retry in', wait, 'ms.');
//       scheduleRetry(wait);
//       return;
//     }

//     isUpdating = true;
//     lastRunAt = now;
//     applyBundleDiscount(1);
//   }

//   function scheduleRetry(delayMs) {
//     if (retryTimer) { clearTimeout(retryTimer); }
//     retryTimer = setTimeout(function () {
//       retryTimer = null;
//       attemptRun();
//     }, delayMs + 20); // small buffer past the exact window edge
//   }

//   console.log(LOG_PREFIX, 'Script loaded, listener attached to cart:refresh.');

//   document.addEventListener('cart:refresh', function () {
//     console.log(LOG_PREFIX, 'cart:refresh event caught.');
//     requestRun();
//   });

//   // UpCart (AfterSell) cart drawer fires this on window whenever it
//   // changes the cart (add, remove, qty change, upsell accepted).
//   window.addEventListener('aftersell-upcart:public-events:cart-updated', function (e) {
//     console.log(LOG_PREFIX, 'UpCart cart-updated event caught.', e.detail);
//     requestRun();
//   });

//   // Fires once when the UpCart drawer finishes initializing (it loads async,
//   // often after DOMContentLoaded) — run a check so the cart is normalized
//   // before the customer first opens the drawer.
//   window.addEventListener('aftersell-upcart:public-events:initialized', function (e) {
//     console.log(LOG_PREFIX, 'UpCart initialized event caught.', e.detail);
//     requestRun();
//   });

//   document.addEventListener('DOMContentLoaded', function () {
//     console.log(LOG_PREFIX, 'DOMContentLoaded — running initial check.');
//     requestRun();
//   });
// })();